export default {"src":"/_next/static/media/sicily.72935bd0.svg","height":459,"width":613,"blurWidth":0,"blurHeight":0};